export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.8a8fecf00e3be7bb41c27a15126b9308.css";